import { render, staticRenderFns } from "./newVersion.vue?vue&type=template&id=6bb8307a&scoped=true&lang=pug&"
import script from "./newVersion.vue?vue&type=script&lang=js&"
export * from "./newVersion.vue?vue&type=script&lang=js&"
import style0 from "./newVersion.vue?vue&type=style&index=0&id=6bb8307a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb8307a",
  null
  
)

export default component.exports